<script>
	import Header from "../components/Header.svelte";


	export let params = {};
	let recipient_name = '';

	onMount(async () => {
	  if (params.recipient_name) {
	    recipient_name = params.recipient_name;
	  }
	});
</script>


<Header />

<div class="formholder">
	<p>A referral has been emailed to {recipient_name}! Be sure to remind them to check their email and book our service so you both get discount! Meanwhile, book your next service <a href='/'>here</a>.</p>
</div>

<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas: "pt pt"
													"pc pc"
													"fn em"
													"rn re"
													"bb . ";
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
			margin-left: auto;
			margin-right: auto;
			display: grid;
			grid-template-columns: 1fr;
			grid-template-areas: "pt"
														"pc"
														"fn"
														"em"
														"rn"
														"re"
														"bb";
		}
	}
</style>